import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ICity, IRegion} from "../../shared/models/models";
import {ServerService} from "../../shared/services/server.service";
import {EventService} from "../../shared/services/event.service";
import { UserInfo } from '../header/header.component';

@Component({
  selector: 'app-select-city',
  templateUrl: './select-city.component.html',
  styleUrls: ['./select-city.component.scss']
})
export class SelectCityComponent implements OnInit {

  @Input() region: IRegion = null;
  @Input() city: ICity = null;

  @Output() selectRegion = new EventEmitter<IRegion>();
  @Output() selectCity = new EventEmitter<ICity>();

  regions: IRegion[] = [];
  cities: ICity[] = [];
  constCities: ICity[] = [];
  user: UserInfo = null;
  search: string = '';
  portalId = null;
  constructor(private serverService: ServerService,
              private eventService: EventService) { }

  ngOnInit() {

    let user = localStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
      if (
        this.user.roles.some(e => e === "MioUser") &&
        this.user.roles.some(e => e === "BDAdmin")
      ) {
      }
      if (
        this.user.roles.some(e => e === "MioUser") &&
        this.user.roles.some(e => e !== "BDAdmin")
      ) {
        this.portalId = 1;
      }
      if (
        this.user.roles.some(e => e !== "MioUser") &&
        this.user.roles.some(e => e === "BDAdmin")
      ) {
      }
    }
    this.serverService.getRegions().then(res => {
      this.regions = res;
      if (this.region) {
        let activeRegion = this.regions.filter(r => r.id == this.region.id)[0];
        if(!activeRegion)
          activeRegion = this.regions[0];
        activeRegion.active = true;
        // let user = localStorage.getItem("user");
        // if (user) {
        //   this.user = JSON.parse(user);
        //   if (this.user.roles[0] === "MioUser") {
        //     this.portalId = 1;
        //   }
        // }
        this.serverService.getCities(activeRegion.id).then(res => {
          this.cities = res;
          this.constCities = res;
          if(this.city !== null){
            let c = this.cities.filter(c => c.id == this.city.id);
            if (c.length > 0) {
                c[0].active = true;
            }
          }
        });
      }
    });

  }

  regionClasses(region: IRegion) {
    let classes = [];
    if (region.active) classes.push('active');
    if (region.id == 1 || region.id == 2) classes.push('white');
    return classes.join(' ');
  }

  setRegion(region: IRegion) {
    this.regions.forEach(r => r.active = false);
    region.active = true;
    this.selectRegion.emit(region);

    this.serverService.getCities(region.id).then(res => {
      this.cities = res;
      this.constCities = res;
    });
    this.eventService.disableBodyScrollbar.emit(true);
  }

  setCity(city: ICity) {
    this.cities.forEach(c => c.active = false);
    city.active = true;
    this.selectCity.emit(city);
    this.eventService.disableBodyScrollbar.emit(true);
  }

  filterCities() {
    if (this.search.length > 0) {
      const reg = new RegExp(this.search, 'i');
      let items = this.cities.filter(i => reg.test(i.name));
      this.cities = items.length > 0 ? items : this.constCities;
    } else {
      this.cities = this.constCities;
    }
  }

}
